<template>
    <div class="collapse show collapse-horizontal aside col-lg-2" id="collapseWidthExample">
      <div class="aside-inner">
        <div class="aside-inner-title">담당자</div>
        <div class="accordion" id="accordionExample">
          <template v-for="depth1 in state.SnbDepth1" :key="depth1.key" >
            <template v-if="depth1.access">

              <div class="accordion-item">
                <h2 class="accordion-header">
                  <ElButton type="accordionSide" :target="depth1.key">
                    {{ depth1.name }}
                  </ElButton>
                </h2>
                <div :id="depth1.key" :class="[isCollapseShow(depth1.showMenuId) ? 'accordion-collapse collapse show' : 'accordion-collapse collapse']">
                  <div class="accordion-body">
                    <ul class="accordion-submenu">
                      <template v-for="item in state.snbDepth2" :key="item.key">
                        <li v-if="item.access && depth1.key == item.key">
                          <router-link 
                            :class="checkActive(item)"
                            :to="item.link"
                          >
                            {{ item.name }}
                          </router-link>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
          </template> 

        </div>
      </div>      
    </div>
   
  </template>
  
<script setup>
import { router } from '@/router';
import {computed} from 'vue'
import { useRoute } from "vue-router";
import { useUserStore } from '@/store/user';
const route = useRoute()
const userStore = useUserStore()


const state = computed(()=>{
  const data = {
      SnbDepth1 :[
          {key : 'sh1',name:'담당자 등록관리',link:'',id: 'M004', access : false,showMenuId:['MSH_SR_001','MSH_SR_002','MSH_SR_003','MSH_SR_004']},
      ],
      snbDepth2 : [
          {key : 'sh1',name:'담당자 등록/수정', link : '/sh/MSH_SR_001',id: 'M004M001', access : false,activeLink : ['/sh/MSH_SR_001','/sh/MSH_SR_003']},
          {key : 'sh1',name:'담당자 조회', link : '/sh/MSH_SR_002',id: 'M004M002', access : false},
      ],
    keyStatus : ''
  }

  const menuList = Object.keys(data).filter(name => name.includes('Depth'))
  menuList.forEach((depth)=>{
    data[depth].forEach((item)=>{
      if (userStore.user) {
        item.access = item.id ? userStore.user.mnUrl.includes(item.id) : true
      }
    })
  })


  Object.values(data).forEach(datum => {
    Object.values(datum).forEach(item => {
      if (item.link.toLowerCase() === route.path.toLowerCase()) {
        if(userStore.user && !item.access){
          alert('접근 불가한 페이지입니다.')
          router.push('/')
          return
        }
        data.keyStatus = item.key
      }
    })
  })

  return data
})

function isCollapseShow(menuList){
  let pathNm = location.pathname.split('/')[location.pathname.split('/').length-1]
  return menuList.includes(pathNm)
}

function checkActive(item){
  let activeFlag = false
  if(item.activeLink){
    activeFlag = item.activeLink.includes(location.pathname)
  }else{
    activeFlag = item.link === location.pathname
  }

  return activeFlag ? 'route-active' : ''
}
</script>